import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useImportDocumentForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: '',
        isTitleHidden: true,
        fields: [
          {
            title: 'Date started',
            name: 'created_at',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Status',
            name: 'status',
            type: 'text',
            readOnly: true,
            format: (vals) => vals?.status?.toLowerCase?.(),
          },
          {
            title: 'Import',
            name: '_import.created_at',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Lender',
            name: '_import._lender.name',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Parseur Document ID',
            name: '_document.parseur_document_id',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Document Type',
            name: '_document.parseur_mailbox_description',
            type: 'text',
            readOnly: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useImportDocumentForm;
